/**
 * Helper functions for form validators
 * @copyright 2024, Selerix Systems, Inc. All Rights Reserved
 * This is unpublished proprietary source code of Selerix, Inc. The
 * copyright notice above does not evidence any actual or intended
 * publication of such source code.
 */

var Page_DomValidationVer = '2';
var Page_IsValid = true;
var Page_BlockSubmit = false;
var Page_ValidationActive = false;
var Page_ValidationPage = null;
var Page_DoNotValidate = new Array;
var Page_Validators = new Array;
var Page_Delimiter = '|~|';

function ValidatorDoNotValidate(dlg) {
    Page_DoNotValidate[Page_DoNotValidate.length] = dlg;
}

function ValidatorOnSubmit() {
    if (Page_ValidationActive) {
        return ValidatorCommonOnSubmit();
    }
    else {
        return true;
    }
}

/*find relation required field validator*/
function GetRelationValidator(node) {
    for (var i = 0; i < node.childNodes.length;) {
        var attr = node.childNodes[i].getAttribute("data-evaluationfunction");

        if (attr && attr == "RequiredFieldValidatorEvaluateIsValid") {
            return node.childNodes[i];
        }
        else {
            return GetRelationValidator(node.childNodes[i]);
        }
    }
}

function ValidatorUpdateDisplay(val) {
    if (val.isrelation) {
        var node = val.parentNode;

        while (node && node.tagName.toLowerCase() != "tr") {
            node = node.parentNode;
        }

        var reqval = GetRelationValidator(node);

        if (reqval) {
            if (reqval.errormessage) {
                reqval.innerText = val.isvalid ? (reqval.message ? reqval.message : reqval.innerText) : reqval.errormessage;
            }

            if (reqval.isvalid) {
                //reqval.style.color = val.isvalid ? reqval.messagecolor : (reqval.errorcolor ? reqval.errorcolor : '#FF0000');
                var r = $(reqval);
                r.removeClass('has-error');
                if (!val.isvalid) r.addClass('has-error');
            }
        }
    }
    else {
        if (val.getAttribute("data-errorlabels") != null && val.getAttribute("data-errorlabels") != "undefined") {
            var labels = val.getAttribute("data-errorlabels");
            var arr = labels.split(Page_Delimiter);

            for (var j = 0; j < arr.length; j++) {
                var lbl = arr[j];
                var control = gE(lbl);

                if (control) {
                    //control.style.color = val.isvalid ? val.messagecolor : (val.errorcolor ? val.errorcolor : '#ff0000');
                    var r = $(control);
                    r.removeClass('has-error');
                    if (!val.isvalid) r.addClass('has-error');
                }
            }
        }
        else {
            var errmsg = val.getAttribute('data-errormessage');
            if (errmsg) {
                if (val.isvalid) {
                    if (val.innerText == errmsg)
                        val.innerText = '';
                }
                else {
                    if (val.innerText == '')
                        val.innerText = errmsg;
                }
            }

            //val.style.color = val.isvalid ? val.messagecolor : (val.errorcolor ? val.errorcolor : '#ff0000');
            var r = $(val);
            r.removeClass('has-error');
            if (!val.isvalid) r.addClass('has-error');
        }
        if (val.isneedchangecontrolstyle) {
            var validateAttr = val.getAttribute("data-controltovalidate");
            var editCtrl = gE(validateAttr);

            if (editCtrl != null) {
                if (!val.isvalid) {
                    if (jQuery(editCtrl).length > 0)
                        jQuery(editCtrl).addClass("xformserrorfield");
                }
                else {
                    if (jQuery(editCtrl).length > 0)
                        jQuery(editCtrl).removeClass("xformserrorfield");
                }
            }
        }
    }

    var controlToValidate = gE(val.getAttribute("data-controltovalidate"));
    if (controlToValidate) {
        if (val.isvalid)
            jQuery(controlToValidate).removeAttr("aria-invalid");
        else
            jQuery(controlToValidate).attr("aria-invalid", "true");
    }

}

function ValidatorUpdateIsValid() {
    var i;

    for (i = 0; i < Page_Validators.length; i++) {
        if (!Page_Validators[i].isvalid) {
            Page_IsValid = false;
            return;
        }
    }

    Page_IsValid = true;
}

function ValidatorHookupControl(control, val) {
    if (typeof (control.tagName) == "undefined" && typeof (control.length) == "number") {
        var i;

        for (i = 0; i < control.length; i++) {
            var inner = control[i];

            if (inner && typeof (inner.value) == "string") {
                ValidatorHookupControl(inner, val);
            }
        }
        return;
    }
    else {
        if (typeof (control.Validators) == "undefined") {
            control.Validators = new Array;
            var ev;

            ev = control.onblur;
            if (typeof (ev) == "function") {
                ev = ev.toString();
                ev = ev.substring(ev.indexOf("{") + 1, ev.lastIndexOf("}"));
            }
            else {
                ev = "";
            }

            var func = new Function('ev', 'id', 'return function() { if (ev) { new Function(ev)(); } ValidatorOnChangeForBaseControls(id); }')(ev, control.id);
            control.onblur = func;

            if (control.type == "radio") {
                ev = control.onclick;
            }
            else {
                ev = control.onchange;
            }

            if (typeof (ev) == "function") {
                ev = ev.toString();
                ev = ev.substring(ev.indexOf("{") + 1, ev.lastIndexOf("}"));
            }
            else {
                ev = "";
            }

            func = new Function('ev', 'id', 'return function() { ValidatorOnChangeForBaseControls(id); if (ev) { new Function(ev)(); } }')(ev, control.id);
            
            if (control.type == "radio") {
                control.onclick = func;
            }
            else {
                control.onchange = func;
            }

        }

        val.messagecolor = val.style.color;
        control.Validators[control.Validators.length] = val;
    }
}

function ComboBoxValueToText(id, value) {
    var control = gE(id);
    var j;

    for (j = 0; j < control.options.length; j++) {
        if (control.options[j].value == value)
            return control.options[j].text;
    }
    return null;
}

function ComboBoxTextToValue(id, text) {
    var control = gE(id);
    var j;

    for (j = 0; j < control.options.length; j++) {
        if (control.options[j].text == text)
            return control.options[j].value;
    }
    return null;
}

function ValidatorGetValue(id) {
    var element = gE(id);
    var control = jQuery(element);

    if (control.length == 0)
        return "";

    //radio button list
    var radioButtons, checkedControl;
    if (control.attr("name")) {
        radioButtons = jQuery("input[name='" + control.attr("name") + "']:radio");
        if (radioButtons.length > 0) {
            checkedControl = radioButtons.filter(':checked:first');
            if (checkedControl.length > 0)
                return checkedControl.val();
            else
                return "";
        }
    }
    else {
        radioButtons = control.find(":radio,:checkbox");
        if (radioButtons.length > 0) {
            checkedControl = radioButtons.filter(':checked:first');
            if (checkedControl.length > 0)
                return checkedControl.val();
            else
                return "";
        }
    }

    if (control.is(":input")) {
        if (typeof (control[0].get_value) == "function") {
            var value = control[0].get_value();
            if (value == null)
                return "";
            return value;
        }
           
        return control.val();
    }
    else
        return "NOT_VALID";
}

function Dlg_DisableValidation(dlg, disable) {
    function doChildren(ctrl) {
        while (ctrl) {
            if (typeof (ctrl.Validators) != "undefined") {
                SetValidatorState(ctrl, disable);
            }

            if (ctrl.firstChild) doChildren(ctrl.firstChild);
            ctrl = ctrl.nextSibling;
        }
    }

    doChildren(dlg.firstChild);
}

function SetValidatorState(ctrl,disable)
{
    if ( ctrl && typeof(ctrl.Validators) != 'undefined')
    {
        var vals = ctrl.Validators;
        for (var i = 0; i < vals.length; i++) vals[i].dontValidate = disable;
    }
}

function Page_ResetValidators() {
    if (typeof (Page_Validators) == "undefined")
        return true;

    for (var i = 0; i < Page_Validators.length; i++) {
        var val = Page_Validators[i];

        val.isvalid = true;
        ValidatorUpdateDisplay(val);
    }

    Page_IsValid = true;
}

function getFocusCtrl(element) {
    if (!element)
        return null;

    if (element.tagName == "SPAN") {
        element = element.firstChild;
    }
    if (element.tagName == "TABLE" || element.tagName == "DIV") {
        var jQueryCtrl = jQuery(element);
        var controls = jQueryCtrl.find('input:text, input:radio, select, a');
        if (controls.length > 0) {
            for (var j = 0; j < controls.length > 1 ? 1 : 0; j++) {
                element = controls[j];
            }
        }
    }
    return element;
}

function ShowSummary(errorList, showFieldError, focusCtrl, showWithEmptyList) {
    $('#errorSummary').remove();
	var errorLinks = '';
	
    for (var i = 0; i < errorList.length; i++) {
        var error = errorList[i];
        var arr = error.split(Page_Delimiter);
        if (arr[0] == '')
            continue;
        errorLinks += "<li class='ui-errorSummaryItem'><a id='validationSummaryError_" + i + "'";
        if (arr[1])
            errorLinks += "onclick='doSetFocus(getFocusCtrl(gE(\"" + arr[1] + "\")), true); return false;'";
        errorLinks += "href='#'";

        errorLinks += "><span class='ui-errorSummaryLabel'>" + arr[0] + "</span>";
		if (showFieldError) {
			var errorWording = arr[2] ? selerix.optionalFieldError : selerix.requiredFieldError;
			if (arr[3] !== void 0 && arr[3] !== '') {
				errorWording = arr[3];
			}

			errorLinks += "<span class='ui-errorSummaryValue'>&nbsp;" + errorWording + "</span>"
		}
        errorLinks +=  "</a></li>";
    }

    if (!showWithEmptyList && errorLinks == '')
        return;

    var parentContainer = null;
	if ($(".modal-body").length > 0 && $(".modal-body").is(':visible')) parentContainer = $(".modal-body:visible");
	if ($(".error-summary-placeholder").length) parentContainer = $(".error-summary-placeholder");
    if (parentContainer === null || !parentContainer.length) parentContainer = $("fieldset").first().parent();
    if (!parentContainer.length) parentContainer = $("#contentContent");
    if (!parentContainer.length) return;    
    else {
        var summary = '<div tabindex="-1" class="ui-errorSummaryContainer" id="errorSummary"><h2 class="ui-errorSummaryHeading">';
        if (!errorLinks) {
            summary += '<a id="validationHeader"';
            if (focusCtrl)
                summary += 'onclick="doSetFocus(gE(\'' + focusCtrl.id + '\'), true); return false;"';
            summary += 'href="#">' + selerix.validatorSummary + '</a>';
        }
        else
            summary += selerix.validatorSummary;
        summary += '</h2>';
        if (errorLinks)
            summary += '<ul class="ui-errorSummaryList">' + errorLinks + '</ul>';
        summary += '</div>';
        parentContainer.prepend(summary);

        if ($("#validationSummaryError_0").length > 0)
            focusCtrl = $("#validationSummaryError_0")[0];
        else if ($("#validationHeader").length > 0)
            focusCtrl = $("#validationHeader")[0];
    }

    if (Page_BusyBox) Page_BusyBox.Hide();

    setTimeout(function () {
    	var el = doSetFocus($('#errorSummary')[0]);
    	if (el.length > 0 && selerix.globals.focusedElementSelector !== void 0) selerix.globals.focusedElementSelector = '#' + el.prop('id');
    }, 10);
}

function Page_ClientValidate() {
    if (typeof (Page_Validators) == "undefined")
        return true;
    var focusCtrl = null;
    var errCount = 0;
    var errorArray = new Array();

    var edit, combo;

    for (var i = 0; i < Page_Validators.length; i++) {
        var val = Page_Validators[i];
        var controltovalidate = gE(val.getAttribute("data-controltovalidate"));
        //ignoring edit template grid form validators
        if (val.getAttribute("type") && val.getAttribute("data-columnkey")) {
            val.isvalid = true;
            val.disabled = true;
            continue;
        }
        else {
            var visible = $(val).is(':visible');

            if (!visible) {
                val.isvalid = true;
                continue;
            }
            var alwaysvalidate = val.getAttribute("data-alwaysvalidate");
            edit = typeof (igedit_getById) != 'undefined' ? igedit_getById(val.getAttribute("data-controltovalidate")) : null;
            combo = typeof (igcmbo_getComboById) != 'undefined' ? igcmbo_getComboById(val.getAttribute("data-controltovalidate")) : null;
            if (controltovalidate == null || (controltovalidate.disabled && alwaysvalidate != "true") || (edit && edit.Element.disabled) || (combo && combo.Element.disabled)) {
                val.isvalid = true;
                continue;
            }

            if (!visible && alwaysvalidate != "true") {
                val.isvalid = true;
                continue;
            }

            if (visible && typeof (gMainPage) != 'undefined' && gMainPage != null) {
                var control = controltovalidate;

                while (control && control.tagName && control.tagName.toLowerCase() != "body" && control.id != gMainPage.id) {
                    control = control.parentNode;

                    if (!visible || control.className == "modal" || $(control).data("show") === false) {
                        visible = false;
                        break;
                    }
                }
            }

            if (!visible) {
                val.isvalid = true;
                continue;
            }

            var ctrl = gE(val.getAttribute("data-controltofocus"));
            edit = typeof (igedit_getById) != 'undefined' ? igedit_getById(val.getAttribute("data-controltofocus")) : null;
            combo = typeof (igcmbo_getComboById) != 'undefined' ? igcmbo_getComboById(val.getAttribute("data-controltofocus")) : null;

            if (ctrl == null || ctrl.disabled || (edit && edit.Element.disabled) || (combo && combo.Element.disabled)) {
                val.isvalid = true;
                continue;
            }
        }

        try {
            ValidatorValidate(val);
        }
        catch (ex) {
            val.isvalid = false;
        }

        if (!val.isvalid) {
            Page_BlockSubmit = true;
            if (controltovalidate != null && val.showSummary) {
                var anchorCtrl = getFocusCtrl(controltovalidate);
				var errorText = val.summaryText ? val.summaryText : (val.getAttribute('data-errormessage') ? val.getAttribute('data-errormessage') : jQuery(val).text());
                var optional = $(controltovalidate.Validators[0]).hasClass('optional') ? Page_Delimiter + 'optional' : '';

				var summaryValue = val.getAttribute('data-summaryValue');
                summaryValue = (summaryValue === void 0 || summaryValue === null || summaryValue === '') ? '' : Page_Delimiter + summaryValue;
                errorText = errorText.trim();
                errorText = errorText.replace(/:$/, "");
                errorArray.push(errorText + Page_Delimiter + anchorCtrl.id + optional + summaryValue);
            }
            errCount++;
            try {
                if (focusCtrl == null) {
                    focusCtrl = getFocusCtrl(gE(val.getAttribute("data-controltofocus")));
                    if (!doSetFocus(focusCtrl, true))
                        focusCtrl = null;
                }
            }
            catch (ex) {
            }
        }
    }

	if (errCount > 0) {		
		ShowSummary(errorArray, true, focusCtrl, true);
    }

    Page_IsValid = errCount == 0;
    Page_BlockSubmit = !Page_IsValid;

    try {
        if (!Page_IsValid) {
            if (!Page_IsValid) {

                if (typeof (ig_cancelEvent) == "function")
                    ig_cancelEvent(null);

                if (event != null) {
                    event.returnValue = false;
                    event.cancelBubble = true;
                    event.preventDefault();
                }
            }
        }
    }
    catch (ex) {
    }

    return Page_IsValid;
}

function ValidatorCommonOnSubmit() {
    var returnValue = !Page_BlockSubmit;
    Page_BlockSubmit = false;
    return returnValue;
}

function ValidateCtrl(ctrl) {
    var bRet = true;
    var vals = ctrl.Validators;

    var oldAlert = $(".validationAlert");
    if (oldAlert.length > 0) {
        oldAlert.remove();
    }

    for (var i = 0; i < vals.length; i++) {
        bRet = ValidatorValidate(vals[i]) && bRet;
        if (!vals[i].isvalid) {
            var parentContainer = $("fieldset").first().parent();
            if (parentContainer.length == 0)
                parentContainer = $("#contentContent");
            if (parentContainer.length == 0)
                parentContainer = $('body');

            var errorText = vals[i].summaryText ? vals[i].summaryText : (vals[i].getAttribute('data-errormessage') ? vals[i].getAttribute('data-errormessage') : jQuery(vals[i]).text());
            if (errorText) {
                var newAlert = document.createElement("div");
                newAlert.setAttribute("role", "alert");
                newAlert.setAttribute("id", "validationAlert_" + vals[i].id);
                newAlert.setAttribute("class", "showToReaders validationAlert");
                var content = document.createTextNode(errorText + " " + selerix.requiredFieldError);
                newAlert.appendChild(content);
                parentContainer.append(newAlert);
            }
        }
    }

    var iconImage = ctrl.getAttribute('data-ImageIconID');
    if (iconImage) {
        var el = document.getElementById(iconImage);
        if (el) {
            var okimage = ctrl.getAttribute("data-ValidatorOKImage");
            var errorImage = ctrl.getAttribute("data-ValidatorErrorImage");

            el.src = bRet ? okimage : errorImage;
        }
    }

    return bRet;
}

function ValidatorOnChangeForInfragistics(oEvent) {
    Page_IsValid = ValidateCtrl(oEvent.srcElement);
}

function ValidatorOnChangeForBaseControls(id) {
    if (id) {
        Page_IsValid = ValidateCtrl(gE(id));
    }
}

function ValidatorValidate(val) {
    val.isvalid = true;

    if (!val.dontValidate && val.isenabled && typeof (val.evalfunc) == "function")
        val.isvalid = val.evalfunc(val);

    ValidatorUpdateDisplay(val);
    return val.isvalid;
}

function AddValidator(val) {
    var ctrl = gE(val.getAttribute("data-controltovalidate"));
    var evalFunction = val.getAttribute("data-evaluationfunction");

    if (typeof (evalFunction) == "string") {
        val.evalfunc = window[evalFunction];
    }
    var isEnabledAttribute = val.getAttribute("data-isenabled");

    if (typeof (isEnabledAttribute) == "string") {
        if (isEnabledAttribute == "false") {
            val.isenabled = false;
        }
        else {
            val.isenabled = true;
        }
    }
    else if (typeof (isEnabledAttribute) == "undefined") {
        val.isenabled = true;
    }

    var isShowSummaryAttribute = val.getAttribute("data-showsummary");

    if (typeof (isShowSummaryAttribute) == "string") {
        if (isShowSummaryAttribute == "false") {
            val.showSummary = false;
        }
        else {
            val.showSummary = true;
        }
    }
    else if (typeof (isShowSummaryAttribute) == "undefined") {
        val.showSummary = true;
    }

    var isValidAttribute = val.getAttribute("data-isvalid");

    if (typeof (isValidAttribute) == "string") {
        if (isValidAttribute == "false") {
            val.isvalid = false;
            Page_IsValid = false;
        }
        else {
            val.isvalid = true;
        }
    }
    else if (typeof (isValidAttribute) == "undefined") {
        val.isvalid = true;
    }

   var hookedCtrl = null;
   if (ctrl) {
        var jQueryCtrl = jQuery(ctrl);
        var validatorHooked = false;
        if (jQueryCtrl.attr("name")) {
            var radioButtons = jQuery("input[name='" + jQueryCtrl.attr("name") + "']:radio");
            if (radioButtons.length > 0) {
                for (var j = 0; j < radioButtons.length; j++) {
                    if (hookedCtrl == null)
                        hookedCtrl = radioButtons[j];
                    ValidatorHookupControl(radioButtons[j], val);
                    validatorHooked = true;
                }
            }
        }
        if (!validatorHooked) {
            if (ctrl.tagName == "TABLE") {
                jQueryCtrl = jQuery(ctrl);
                var controls = jQueryCtrl.find('input:text, input:radio, select');
                if (controls.length > 0) {
                    for (var j = 0; j < controls.length; j++) {
                        if (hookedCtrl == null)
                            hookedCtrl = controls[j];
                        ValidatorHookupControl(controls[j], val);
                        validatorHooked = true;
                    }
                }
            }
            if (!validatorHooked)
                ValidatorHookupControl(ctrl, val);
        }
    }

    if (hookedCtrl != null)
        jQuery(val).attr("for", hookedCtrl.id);

    var isNeedChangeControlStyle = val.getAttribute("data-isneedchangecontrolstyle");

    if (typeof (isNeedChangeControlStyle) == "string") {
        if (isNeedChangeControlStyle == "false") {
            val.isneedchangecontrolstyle = false;
        }
        else {
            val.isneedchangecontrolstyle = true;
        }
    }
    else if (typeof (isNeedChangeControlStyle) == "undefined") {
        val.isneedchangecontrolstyle = false;
    }

    var messagecolor = val.getAttribute("data-messagecolor");

    if (typeof (messagecolor) == "string") {
        val.messagecolor = messagecolor;
    }
    var errorcolor = val.getAttribute("data-errorcolor");

    if (typeof (errorcolor) == "string") {
        val.errorcolor = errorcolor;
    }

    var summaryText = val.getAttribute("data-summaryText");
    if (summaryText)
        val.summaryText = summaryText;
}

function ValidatorOnLoad() {
    if (typeof (Page_Validators) == "undefined")
        return;

    for (var i = 0; i < Page_DoNotValidate.length; i++) {
        Dlg_DisableValidation(Page_DoNotValidate[i], true);
    }

    Page_ValidationActive = true;
}

function RangeValidatorEvaluateIsValid(val) {
    var value = ValidatorGetValue(val.getAttribute("data-controltovalidate"));

    if (value == "" || val.getAttribute("data-minvalue") == "" || val.getAttribute("data-maxvalue") == "")
        return true;

    value = parseInt(value);
    var minValue = parseInt(val.getAttribute("data-minvalue"));
    var maxValue = parseInt(val.getAttribute("data-maxvalue"));

    if (value >= minValue && value <= maxValue) {
        return true;
    }

    return false;
}

function CompareValidatorEvaluateIsValid(val) {
    var value = ValidatorGetValue(val.getAttribute("data-controltovalidate"));

    if (val.getAttribute("data-controltocompare")) {
        var compareValue = ValidatorGetValue(val.getAttribute("data-controltocompare"));
        return value == compareValue;
    }

    return true;
}

function RegularExpressionValidatorEvaluateIsValid(val) {
    var value = ValidatorGetValue(val.getAttribute("data-controltovalidate")).toString().trimEnd().trimStart();
    var emptyAllowed = val.getAttribute("data-allowemptyvalues");

    if (value == "")
        return emptyAllowed == "true";

    var validationExpression = val.getAttribute("data-validationexpression");
    if (validationExpression) {
        var rx = new RegExp(val.getAttribute("data-validationexpression"));
        var matches = rx.exec(value);

        var match = matches != null && value == matches[0];
        if (match)
            return match;

        var ctrl = $(gE(val.getAttribute("data-controltovalidate")));
        var valueWithMask = ctrl.val();
        matches = rx.exec(valueWithMask);
        return (matches != null && valueWithMask == matches[0]);
    }

    return true;
}

function DateInPastValidator(val) {
	var ctrlVal = $('#' + $(val).data("controltovalidate")).val();	

	var nowDateTime = new Date(Date.now());
	var valAsDateTime = new Date(ctrlVal);
	var nowDate = new Date(nowDateTime.getFullYear(), nowDateTime.getMonth(), nowDateTime.getDate());
	var valDate = new Date(valAsDateTime.getFullYear(), valAsDateTime.getMonth(), valAsDateTime.getDate());

	if (valAsDateTime !== "Invalid Date" && nowDate > valDate) {
		return false;
	}
	return true;
}

function SecureMaskEditorEvaluateIsValid(val) {
    var valid = true;
    var ctrl = $('#' + $(val).data("controltovalidate"));
    if (ctrl.length > 0) {
        var hiddenText = $('#' + ctrl.data('controltextid'));
        var hiddenValue = $('#' + ctrl.data('controlvalueid'));
        if (hiddenText.length > 0 && hiddenValue.length > 0) {
            var text = $.trim(hiddenText.val());
            var value = $.trim(hiddenValue.val());
            var emptyAllowed = $(val).data("allowemptyvalues");
            if (emptyAllowed && value == "")
                return true;

            var mask = ctrl.data('editmodemask');
            var regExpr = "";
            for (var i = 0; i < mask.length; i++) {
                switch (mask.charAt(i)) {
                    case "0":
                        regExpr += "\\d";
                        break;
                    case "9":
                        regExpr += "[\\d]?";
                        break;
                    case "#":
                        regExpr += "[\\d+-]?";
                        break;
                    case "L":
                        regExpr += "[a-zA-Z]";
                        break;
                    case "?":
                        regExpr += "[a-zA-Z]?";
                        break;
                    case "&":
                        regExpr += "[\\p{Ll}\\p{Lu}\\p{Lt}\\p{Lm}\\p{Lo}]";
                        break;
                    case "C":
                        regExpr += "[\\p{Ll}\\p{Lu}\\p{Lt}\\p{Lm}\\p{Lo}]?";
                        break;
                    case "A":
                        regExpr += "\\W";
                        break;
                    default:
                        regExpr += mask.charAt(i);
                        break;
                }
            }

            var rx = new RegExp(regExpr);
            var matches = rx.exec(text);
            valid = valid && (matches != null && text == matches[0]);
        }
    }
    return valid;
}

function ValidatorTrim(s) {
    return s == null ? '' : escape(s.toString()).replace(/^\s*/, '').replace(/\s*$/, '');
}

function RequiredFieldValidatorEvaluateIsValid(val) {
    var value = ValidatorTrim(ValidatorGetValue(val.getAttribute("data-controltovalidate")));

    return (value != ValidatorTrim(val.getAttribute("data-initialvalue")));
}

jQuery.fn.center = function () {
    this.css("position", "absolute");
    this.css("top", (jQuery(window).height() - this.height()) / 2 + jQuery(window).scrollTop() + "px");
    this.css("left", (jQuery(window).width() - this.width()) / 2 + jQuery(window).scrollLeft() + "px");
    return this;
}

// @Obsolete('Use createDialog()')
function showStatusMessageBox(message, showCancel, warningType) {
    var k = typeof okayAction === 'function' ? okayAction : function () {
        var redirectUrl = $('input[id$=modalErrorRedirect]');
        if (redirectUrl.length > 0) {
            window.location.href = redirectUrl.val();
        }

        return true;
    };
    var x = typeof cancelAction === 'function' ? cancelAction : function () { return false; };
    var settings = {
		message: message, state: warningType,
		buttons: [{ text: "OK", defaultButton: true, action: k }]
    };

    if (warningType === 'danger') {
        settings.title = 'Error';
	}

	if (showCancel) settings.buttons.push({ text: "Cancel", action: x });
	createDialog(settings);
}